import React, { Component } from 'react'
import { observer } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import { Button, Icon, Upload, InputNumber, message, Row, Spin, Modal, Tooltip } from "antd"

import moment from 'moment'

@observer
export default class DownloadLinkModal extends Component {
  beforeUpload = (file) => {
    const { addFile } = this.props.store
    const fileType = file.name.split(".").pop()
    if (fileType !== 'txt') {
      message.error("您上传的文件格式不正确^.^")
      return false
    }
    addFile(file)
    return false
  }

  uploadFiles = (dataType) => {
    const { type } = this.props
    const { uploadFiles, files } = this.props.store   
    uploadFiles(type, dataType)
    if (files.length === 1) {
      this.props.store.linkModalShowed = true
    }
  }

  clearFiles = () => {
    const { onClose } = this.props
    onClose()
    this.props.store.files = []
  }

  render() {

    const { onInputNumberChange, files } = this.props.store
    return (
      <MaterialModal
        title="数据下载"
        visible
        width={600}
        footer={false}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => this.clearFiles()}
        />
        <div className="upload-block">
          <Row>
            <Upload
              className="pull-left"
              beforeUpload={this.beforeUpload}
            >
              <Tooltip
                placement="topRight"
                title="请选择指定格式的txt文件，包含样本id或报告id"
              >
                <Button type="ghost">
                  <Icon type="plus" />
                  请选择文件
              </Button>
              </Tooltip>

            </Upload>
            <span style={{ marginLeft: 10 }}>
              链接有效期（天）：
            </span>
            <InputNumber
              min={1}
              defaultValue={1}
              onChange={onInputNumberChange}
            />
          </Row>
          <Row>
            {files.map((file, index) => (
              <p className="upload-file-name" key={index}>
                文件名：{file.name}
                <span
                  style={{ marginLeft: 10 }}
                >
                  {moment(file.fileObject.lastModified).format("YYYY-MM-DD HH:mm")}
                </span>
              </p>
            ))}
          </Row>
          <Button
            type='primary'
            onClick={() => this.uploadFiles('offline')}
          >
            下载数据链接
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={() => this.uploadFiles('online')}
          >
            样本下载
          </Button>
          <Button
            type="primary"
            onClick={() => this.uploadFiles('results')}
            style={{ marginLeft: 10 }}
          >
            下载报告链接
          </Button>
          <span
            style={{
              marginLeft: 10,
              color: '#286cac'
            }}
          >
            注：请在晚7点到次日早6点之间操作
          </span>
        </div>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.props.store.linkModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/DownloadLinkModal.js